import { isObject } from '@zoryn/utils'

import type { ExtractPropTypes, PropType } from 'vue'
import type {
  FieldDefinition,
  FormCreateApi,
  FormCreateOption,
  FormRule,
} from './types'

export const formCreateProps = {
  rule: {
    type: Array as PropType<FormRule[]>,
    default: () => [],
  },
  option: {
    type: Object as PropType<FormCreateOption>,
    default: () => ({}),
  },
  modelValue: {
    type: Object as PropType<Record<string, unknown>>,
    default: () => ({}),
  },
  api: {
    type: Object as PropType<FormCreateApi>,
    default: undefined,
  },
  disabled: Boolean,
  preview: Boolean,
  components: {
    type: Object as PropType<Record<string, FieldDefinition | object>>,
    default: undefined,
  },
} as const

export type FormCreateProps = ExtractPropTypes<typeof formCreateProps>

export const formCreateEmits = {
  'update:modelValue': (value: Record<string, unknown>) => isObject(value),
  'update:api': (value: FormCreateApi) => isObject(value),
  submit: (value: Record<string, unknown>) => isObject(value),
  reset: (value: Record<string, unknown>) => isObject(value),
  fail: (error: unknown) => error !== undefined,
}

export type FormCreateEmits = typeof formCreateEmits
